module.exports = __webpack_public_path__ + "assets/img/20_1001.f75ee03a.jpg";